var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.quota)?_c('div',{staticClass:"quotas"},[_c('div',{staticClass:"quotas__wrap"},_vm._l((_vm.quota),function(quotaItem,itemType){return _c('PlanQuotaItem',{key:itemType,attrs:{"quota":quotaItem,"item-type":itemType}})}),1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }